import React from "react";
import { Box, Paper, Typography } from "@mui/material";

export default function HighlightList({ highlights = [] }) {
  if (!highlights.length) return null;

  return (
    <Box sx={{ display: "grid", gap: 1.2 }}>
      {highlights.map((item, index) => (
        <Paper
          key={`${item.title}-${index}`}
          elevation={0}
          sx={{
            borderRadius: "18px",
            p: 2,
            border: "1px solid #e8eef6",
            backgroundColor: "#fbfdff",
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 700, color: "#15243b" }}>
            {item.title}
          </Typography>
          <Typography variant="body2" sx={{ mt: 0.45, color: "#6f7f95" }}>
            {item.body}
          </Typography>
        </Paper>
      ))}
    </Box>
  );
}
